import { messaging } from './firebase'; 
import { getToken } from 'firebase/messaging';

export const requestNotificationPermission = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator) || !('Notification' in window)) {
    console.error('Environment does not support service workers or notifications');
    return null;
  }

  try {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      console.warn(' Notification permission not granted');
      return null;
    }

    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/',
    });
  

    const token = await getToken(messaging, {
      vapidKey: 'BCc76R0tT-5_6BI3MZVQh3FinfMqcwyxVxX73wGKXNJY_SpTS3wtYT6j8E5GhYOT_8XDrGMbGsUEizdXp_IlAbs',
      serviceWorkerRegistration: registration,
    });

   
    return token;
  } catch (err) {
    console.error(' FCM Error:', err.message || err);
    return null;
  }
};

export default requestNotificationPermission;
